import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { registerLicense } from '@syncfusion/ej2-base';

// Suppress known harmless console errors
const originalError = console.error;
console.error = (...args: any[]) => {
  const msg = args[0]?.toString?.() || '';
  if (msg.includes('No checkout popup config found')) return;
  if (msg.includes('Could not establish connection')) return;
  if (msg.includes('Receiving end does not exist')) return;
  if (msg.includes('runtime.lastError')) return;
  originalError.apply(console, args);
};

const originalLog = console.log;
console.log = (...args: any[]) => {
  const msg = args[0]?.toString?.() || '';
  // Filter Bitwarden extension noise
  if (msg.includes('Migrator') && msg.includes('should migrate')) return;
  if (msg.includes('[CipherService]')) return;
  if (msg.includes('[SearchService]')) return;
  if (msg.includes('WebPush for server notifications')) return;
  if (msg.includes('Environment did not respond')) return;
  if (msg.includes('State version:')) return;
  if (msg.includes('WASM SDK loaded')) return;
  if (msg.includes('WebAssembly is supported')) return;
  if (msg.includes('Retrieving application id')) return;
  originalLog.apply(console, args);
};

// Registering Syncfusion license key (v34.1.29 -- matches CO's key for the same version)
// registerLicense('Ngo9BigBOggjHTQxAR8/V1JHaF5cWWdCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdlWXlccHRUQmZZU0FwVkFWYEo='); // v33.2.3
registerLicense('Ngo9BigBOggjHTQxAR8/V1JAaF5cX2pCd1p/TH5YfUNzdUVEY1ZUTXxaS1ZhSXxVdkJhWH1dcXJVRWZdV0x9XEY=');

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error('Root element not found');

const root = ReactDOM.createRoot(rootElement);
root.render(
  <App />
);